import { createSlice } from "@reduxjs/toolkit";
// import { apiEndpoints } from "../api";
// import { apiCallBegan } from "./apiActions";

import channelsService from "../services/channelsService";

import { ADD_ERROR } from "./errors";
import { getCurrentChannelMessages, deleteMessages } from "./messages";
import { reset } from "redux-form";
import userService from "../services/userService";
import messagesService from "../services/messagesService";

//%-<<*----------  NEEDED ENDPOINTS FOR THIS PARTICULAR REDUCER  ----------*>>-%//

// const {} = apiEndpoints;

//%-<<*----------  REDUCERS AND ACTION TYPES  ----------*>>-%//

const channelsSlice = createSlice({
    name: "channels",
    initialState: {
        channels: [],
        currentChannel: null,
        isPrivateChannel: false,
        starredChannels: [],
        userPosts: [],
        loading: false,
    },

    reducers: {
        START_LOADING: messages => {
            messages.loading = true;
        },

        CREATE_CHANNEL: (channels, { payload }) => {
            Object.assign(channels, {
                channels: [...channels.channels, payload],
                isPrivateChannel: false,
                loading: false,
            });
        },

        GET_CHANNELS: (channels, { payload }) => {
            Object.assign(channels, { channels: payload, loading: false });
        },

        SET_CURRENT_CHANNEL: (channels, { payload }) => {
            if (!payload) Object.assign(channels, { currentChannel: null, isPrivateChannel: false, userPosts: [] });
            else {
                const { isPrivateChannel = false, ...currentChannel } = payload;

                Object.assign(channels, { currentChannel: currentChannel, isPrivateChannel });
            }
        },

        DELETE_CHANNEL: (channels, { payload }) => {
            Object.assign(channels, { channels: channels.channels.filter(({ id }) => id !== payload.id), loading: false });
        },

        STAR_CHANNEL: (channels, { payload: { type, channel } }) => {
            Object.assign(channels, {
                starredChannels:
                    type === "star"
                        ? [...channels.starredChannels, channel]
                        : channels.starredChannels.filter(({ id }) => id !== channel.id),
                loading: false,
            });
        },

        GET_USER_STARRED_CHANNELS: (channels, { payload }) => {
            Object.assign(channels, { starredChannels: payload, loading: false });
        },

        COUNT_USER_POSTS: (channels, { payload }) => {
            channels.userPosts = payload;
        },
    },
});

export default channelsSlice.reducer;

//%-<<*----------  ACTIONS TYPES  ----------*>>-%//

const {
    CREATE_CHANNEL,
    GET_CHANNELS,
    SET_CURRENT_CHANNEL,
    DELETE_CHANNEL,
    STAR_CHANNEL,
    START_LOADING,
    GET_USER_STARRED_CHANNELS,
    COUNT_USER_POSTS,
} = channelsSlice.actions;

//%-<<*----------  API -- ACTIONS  ----------*>>-%//

export const createChannel = data => async dispatch => {
    try {
        const channel = await channelsService.createChannel(data);

        dispatch({ type: CREATE_CHANNEL.type, payload: channel });

        dispatch(setCurrentChannel(channel));
    } catch ({ message }) {
        dispatch({ type: ADD_ERROR.type, payload: { name: createChannel.name, message } });
    }
};

export const getChannels = () => async (dispatch, getState) => {
    dispatch({ type: START_LOADING.type });

    dispatch({ type: GET_CHANNELS.type, payload: await channelsService.getChannels() });

    dispatch({ type: GET_USER_STARRED_CHANNELS.type, payload: await userService.getUserStarredChannels() });

    const { channels } = getState().channels;

    channels.length && dispatch(setCurrentChannel(channels[0]));
};

export const setCurrentChannel = payload => (dispatch, getState) => {
    if (getState().channels.currentChannel?.id === payload?.id) return;

    dispatch(reset("searchMessages", "search"));
    dispatch(reset("createMessage", "message"));

    dispatch({ type: SET_CURRENT_CHANNEL.type, payload });

    payload && dispatch(getCurrentChannelMessages(payload.id));
};

export const deleteChannel = channelId => async (dispatch, getState) => {
    const { channels, currentChannel } = getState().channels;

    dispatch({ type: DELETE_CHANNEL.type, payload: await channelsService.deleteChannel(channelId) });

    await dispatch(deleteMessages(channelId));

    await dispatch(starChannel("starred", { id: channelId }));

    await userService.removeStarredChannelFromAllUsers(channelId);

    await messagesService.removeChannelTypingRef(channelId);

    currentChannel.id === channelId &&
        dispatch(setCurrentChannel(channels[channels.findIndex(({ id }) => id === channelId) - 1] || null));
};

export const starChannel = (type, channel) => async dispatch => {
    dispatch({ type: STAR_CHANNEL.type, payload: await userService.updateUserWithStarredChannels(type, channel) });
};

export const countUserPosts = messages => dispatch => {
    //->>: WE COULDN'T USE .MAP-METHOD HERE CAUSE WE WANNA ACCESS THE RESULT ARRAY WITHIN THE METHOD SO WITHIN THE LOOP TO INCREMENT THE OBJECT-ITEM WITH THE SAME NAME AND WE CANNOT ACCESS IT WITHIN THE .MAP-METHOD SO WE USED .REDUCE-METHOD AND MAKE USE OF NAMES AS KEYS AND THEN WE CONVERT THE RESULT OBJECT TO AN ARRAY.
    const userPosts = messages.reduce((acc, message) => {
        // if (message.user.name in acc) acc[message.user.name].count += 1;
        // else acc[message.user.name] = { avatar: message.user.avatar, count: 1 };

        // return acc;

        //->>: SAME RESULT AS ABOVE:
        return {
            ...acc,
            [message.user.name]: { avatar: message.user.avatar, count: (acc[message.user.name]?.count || 0) + 1 },
        };
    }, {});

    const payload = Object.entries(userPosts)
        .map(([name, value]) => ({ name, ...value }))
        .sort((a, b) => b.count - a.count);

    dispatch({ type: COUNT_USER_POSTS.type, payload });
};
